import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "cv_cookie_consent";

const updateConsent = (granted) => {
  if (typeof window.gtag !== "function") return;
  const value = granted ? "granted" : "denied";
  window.gtag("consent", "update", {
    ad_storage: value,
    analytics_storage: value,
    ad_user_data: value,
    ad_personalization: value,
  });
};

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "granted") {
      updateConsent(true);
    } else if (!stored) {
      setVisible(true);
      document.body.classList.add("cv-cookie-open");
    }
    return () => document.body.classList.remove("cv-cookie-open");
  }, []);

  const choose = (granted) => {
    localStorage.setItem(STORAGE_KEY, granted ? "granted" : "denied");
    updateConsent(granted);
    setVisible(false);
    document.body.classList.remove("cv-cookie-open");
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 inset-x-0 z-[100] bg-[#121212] border-t-2 border-[#C5A059] px-4 sm:px-6 py-4 shadow-[0_-8px_30px_rgba(0,0,0,0.4)]"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-5 h-5 text-[#C5A059] shrink-0 mt-0.5" />
          <p className="font-serif-display text-sm sm:text-base text-[#EDE6D6] leading-relaxed">
            CurioVault uses cookies to measure curiosity.{" "}
            <Link
              to="/privacy"
              data-testid="cookie-consent-privacy-link"
              className="text-[#C5A059] underline underline-offset-2 hover:text-[#e0bf78]"
            >
              See our privacy policy.
            </Link>
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0 self-end sm:self-auto">
          <button
            data-testid="cookie-consent-deny"
            onClick={() => choose(false)}
            className="px-5 py-2 text-sm font-mono-cv tracking-wide text-[#EDE6D6] border border-[#4A4A4A] rounded-sm hover:border-[#EDE6D6] transition-colors"
          >
            Deny
          </button>
          <button
            data-testid="cookie-consent-accept"
            onClick={() => choose(true)}
            className="px-5 py-2 text-sm font-mono-cv tracking-wide text-[#121212] bg-[#C5A059] rounded-sm hover:bg-[#e0bf78] transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};
